import React from 'react';
import {Typography} from "@material-tailwind/react";
import {
    GlobeAltIcon,
    PhoneArrowDownLeftIcon,
    InboxArrowDownIcon,
    ClockIcon, EnvelopeIcon,
} from "@heroicons/react/24/outline";
import {LandingMenu} from "../components/common/LandingMenu";
import {PhoneIcon} from "@heroicons/react/16/solid";
import {Link} from "react-router-dom";
import {Menu} from "../components/common/Menu";

import { motion } from 'framer-motion';

function ONamaPage() {

    const isAuthenticated = !!localStorage.getItem("token");

    const currentYear = new Date().getFullYear();

    return (
        <>
            <div className="overflow-hidden">
                <div className="justify-center w-[calc(100%)] min-h-screen bg-white">
                    <div className="h-5 bg-gray-50"></div>

                    <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                        {/* Levi krug */}
                        <div className="absolute w-[35vw] h-[35vw] bg-blue-100 rounded-full mix-blend-multiply filter blur-2xl opacity-50 animate-blob"
                             style={{ top: '90%', left: '30%', transform: 'translate(-80%, -50%)' }}></div>
                        {/* Desni krug */}
                        <div className="absolute w-[35vw] h-[35vw] bg-red-100 rounded-full mix-blend-multiply filter blur-2xl opacity-50 animate-blob animation-delay-2000"
                             style={{ top: '80%', left: '60%', transform: 'translate(-20%, -50%)' }}></div>
                        {/* Donji krug */}
                        {/*<div className="absolute w-[35vw] h-[35vw] bg-blue-100 rounded-full mix-blend-multiply filter blur-2xl opacity-50 animate-blob animation-delay-4000"*/}
                        {/*     style={{ top: '120%', left: '60%', transform: 'translate(-50%, 10%)' }}></div>*/}
                    </div>
                    <div className="mx-2">
                        {isAuthenticated ? <Menu /> : <LandingMenu />}

                        <motion.div
                            initial={{ opacity: 0, y: -100 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.75 }}
                        >

                        <div className="h-6 bg-grayblue-50"></div>
                        <div className="container mx-auto flex flex-col relative z-10">

                            <div className="flex flex-col sm:flex-row gap-4 sm:gap-x-32 mt-8 ml-2 mr-2">
                                {/* Prvi div - O nama */}
                                <div className="w-full sm:w-1/2">
                                    <span className="block text-blue-600 text-xl sm:text-2xl font-semibold mt-4 mb-6">O nama</span> {/* Plavi tekst sa razmakom */}
                                    <h2 className="text-3xl sm:text-3xl font-normal">
                                        <span className="text-blue-500">Zašto Smart Service System?</span>
                                    </h2>
                                    <p className="mt-8 text-[17px] sm:text-xl font-light mb-8">
                                        Mi smo firma koja se <span className="font-semibold">specijalizovala</span> za očitavanje merila toplotne energije i raspodelu utroška energenta, sa misijom
                                        da svojim korisnicima omogućimo preciznu kontrolu nad potrošnjom energije.
                                        <span className="block h-[8px]"></span>
                                        Od 2016. godine, pomažemo kako domaćinstvima, tako i poslovnim korisnicima da bolje razumeju i upravljaju svojim energetskim resursima.
                                    </p>

                                    <p className="mt-8 text-[17px] sm:text-xl font-light mb-8">
                                        <span className="font-bold">Kvalitet i preciznost</span> su naša osnovna <span className="font-semibold">vrednost</span>, pa se trudimo da kroz stalnu edukaciju i unapređenje usluga budemo najbolji u onome što radimo.
                                        <span className="block h-[8px]"></span>
                                        Verujemo u <span className="font-bold">transparentnost i pouzdanost</span>, što nas čini idealnim partnerom za sve koji žele da unaprede upravljanje svojim energetskim troškovima.
                                    </p>
                                </div>

                                {/* Drugi div - Usmereni poslovi */}
                                <div className="w-full sm:w-1/2">
                                    <div className="w-full flex items-center justify-start lg:justify-center">
                                        <img
                                            src="/transparent logo.png"
                                            alt="Smart Service System Logo"
                                            className="h-[6.75rem] w-auto"
                                        />
                                    </div>
                                    <p className="mt-8 text-[17px] sm:text-xl font-light mb-8">
                                        Naš stručni tim koristi <span className="font-semibold">najnoviju</span> tehnologiju za očitavanje merača toplotne energije, omogućavajući tačne, pravovremene
                                        i efikasne podatke koji pomažu u optimizaciji potrošnje gasa i električne energije.
                                        <span className="block h-[8px]"></span>
                                        Raspodela potrošnje gasa i električne energije koju pružamo korisnicima zasniva se na detaljnoj analizi, a naši izveštaji omogućavaju jasno razumevanje troškova i unapređenje energetske efikasnosti.
                                    </p>

                                    <p className="mt-8 text-[17px] sm:text-xl font-light mb-8">
                                        Ako želite da <span className="font-semibold">optimizujete</span> potrošnju, uštedite energiju ili jednostavno imate pitanje vezano za očitavanje merača toplotne energije, naš tim je tu da vam pruži najefikasnija rešenja.
                                        <span className="block h-[8px]"></span>
                                        Kontaktirajte nas i saznajte kako možemo doprineti vašoj energetskoj efikasnosti.
                                    </p>
                                </div>
                            </div>

                            <div
                                className="w-full h-[8rem] sm:h-[20rem] md:h-[20rem] rounded-lg bg-cover bg-center"
                                style={{ backgroundImage: "url('/images/o-nama-page/q-caloric-heizkostenverteiler.jpg')" }}
                            ></div>

                            <div className="flex flex-col sm:flex-row gap-8 sm:mt-12 md:mt-20 mt-8 sm:mb-12 md:mb-20 mb-4 ml-2">
                                {/* Website */}
                                <div className="flex items-center gap-4 w-full sm:w-1/4">
                                    <GlobeAltIcon className="h-8 w-8 text-blue-600" />
                                    <div className="flex flex-col">
                                        <span className="text-lg font-light">Website</span>
                                        <a href="https://www.smartservicesystem.rs" className="text-lg text-blue-500">www.smartservicesystem.rs</a>
                                    </div>
                                </div>

                                {/* E-Mail */}
                                <div className="flex items-center gap-4 w-full sm:w-1/4">
                                    <InboxArrowDownIcon className="h-8 w-8 text-blue-600" />
                                    <div className="flex flex-col">
                                        <span className="text-lg font-light">E-Mail</span>
                                        <a href="mailto:info@smartservicesystem.com" className="text-lg text-blue-500">info@smartservicesystem.rs</a>
                                    </div>
                                </div>

                                {/* Kontakt telefon */}
                                <div className="flex items-center gap-4 w-full sm:w-1/4">
                                    <PhoneArrowDownLeftIcon className="h-8 w-8 text-blue-600" />
                                    <div className="flex flex-col">
                                        <span className="text-lg font-light">Kontakt telefon</span>
                                        <a href="tel:+381615280018" className="text-lg text-blue-500">+381 61 528 00 18</a>
                                    </div>
                                </div>

                                {/* Radno vreme */}
                                <div className="flex items-center gap-4 w-full sm:w-1/4">
                                    <ClockIcon className="h-8 w-8 text-blue-600" />
                                    <div className="flex flex-col">
                                        <span className="text-lg font-light">Radno vreme</span>
                                        <div className="flex items-center gap-2">
                                            <span className="text-lg text-blue-500">12e-14h</span>
                                            <span className="text-lg font-light">ponedeljak - petak</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="flex gap-4 mt-24 mb-4">
                                <footer className="relative w-full">
                                    <div className="mx-auto w-full max-w-7xl px-8">
                                        <div className="mx-auto grid w-full grid-cols-1 gap-8 py-12 md:grid-cols-2 lg:grid-cols-4">

                                            <div className="w-full flex items-center justify-start lg:justify-center">
                                                <img
                                                    src="/transparent logo.png"
                                                    alt="Smart Service System Logo"
                                                    className="h-24 w-auto"
                                                />
                                            </div>

                                            <div className="w-full">
                                                <Typography variant="small" className="mb-4 font-bold uppercase text-gray-900">
                                                    Navigacija
                                                </Typography>
                                                <ul className="space-y-1">
                                                    <Link to="/">
                                                        <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                            <span className="inline-block py-1 pr-2">Početna strana</span>
                                                        </Typography>
                                                    </Link>
                                                    <Link to="/o_nama">
                                                        <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                            <span className="inline-block py-1 pr-2">O nama</span>
                                                        </Typography>
                                                    </Link>
                                                    <Link to="/saveti">
                                                        <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                            <span className="inline-block py-1 pr-2">Saveti</span>
                                                        </Typography>
                                                    </Link>
                                                    <Link to="/kontakt">
                                                        <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                            <span className="inline-block py-1 pr-2">Kontakt</span>
                                                        </Typography>
                                                    </Link>
                                                </ul>
                                            </div>

                                            <div className="w-full">
                                                <Typography variant="small" className="mb-4 font-bold uppercase text-gray-900">
                                                    Kontakt
                                                </Typography>
                                                <ul className="space-y-1">
                                                    <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                        <span className="inline-block py-1 pr-2">Za sva Vaša pitanja</span>
                                                    </Typography>
                                                    <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                        <span className="inline-block py-1 pr-2">stojimo na raspolaganju</span>
                                                    </Typography>
                                                    <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                        <span className="inline-block py-1 pr-2">svakog radnog dana</span>
                                                    </Typography>
                                                    <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                        <span className="inline-block py-1 pr-2">od 12-14h</span>
                                                    </Typography>
                                                </ul>
                                            </div>

                                            <div className="w-full">
                                                <div className="flex items-center space-x-4 mb-4">
                                                    <GlobeAltIcon className="h-5 w-5 text-gray-900" />
                                                    <EnvelopeIcon className="h-5 w-5 text-gray-900" />
                                                    <PhoneIcon className="h-5 w-5 text-gray-900" />
                                                </div>
                                                <ul className="space-y-1">
                                                    <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                        <span className="inline-block py-1 pr-2">www.smartservicesystem.rs</span>
                                                    </Typography>
                                                    <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                        <span className="inline-block py-1 pr-2">info@smartservicesystem.rs</span>
                                                    </Typography>
                                                    <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                        <span className="inline-block py-1 pr-2">+381 61 528 00 18</span>
                                                    </Typography>
                                                    <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                        <a  href="/Politika%20privatnosti.pdf" target="_blank" rel="noopener noreferrer" className="inline-block py-1 pr-2">Politika privatnosti</a>
                                                    </Typography>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="flex w-full flex-col items-center justify-center border-t border-blue-gray-50 py-4 md:flex-row md:justify-between">
                                            <Typography
                                                variant="small"
                                                className="mb-4 text-center font-normal text-blue-gray-900 md:mb-0"
                                            >
                                                &copy; {currentYear} <a href="https://smartservicesystem.rs/">Smart Service System</a>. Sva
                                                prava zadržana.
                                            </Typography>
                                        </div>
                                    </div>
                                </footer>
                            </div>

                        </div>
                        </motion.div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ONamaPage;